<div class="widget-container">
  @if (widgetConfig(); as config) {
    <dojo-widget [config]="config" />
  }
</div>
